import { useContext, useState, useEffect, useRef } from "react";
import { getUserBootcampData, generateUserBootcampData } from "../facades/UserFacade";
import { UserContext } from "../contexts/userContext";
import { decodeHtmlEntity } from "../utils";
import {
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    Container,
    IconButton,
    Stack,
    TextField,
    Typography,
    Paper,
    Chip
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SchoolIcon from "@mui/icons-material/School";
import EditIcon from "@mui/icons-material/Edit";

const assistToMainMappings = {
  "4430": 3745,
  "4459": 3806,
  "4451": 191474,
  "4435": 3961,
  "10811": 5126,
  "10838": 5187,
  "10880": 5190,
  "10929": 371311,
  "96897": 94943,
  "249412": 249353
}

const getCourseFullName = (course_name) => {

    switch (course_name) {
        case "ethics-governance":
            return "Ethics & Governance"
        case "australia-taxation-advanced":
            return "Australia Taxation - Advanced"
        case "global-strategy-leadership":
            return "Global Strategy & Leadership"
        case "financial-reporting":
            return "Financial Reporting"
        case "strategic-management-accounting":
            return "Strategic Management Accounting"
        case "advanced-audit-assurance":
            return "Advanced Audit & Assurance"
        case "australia-taxation":
            return "Australia Taxation"
        case "contemporary-business-issues":
            return "Contemporary Business Issues"
        case "financial-risk-management":
            return "Financial Risk Management"
        case "digital-finance":
            return "Digital Finance"
        default:
            return "CPA program"
    }
}
const courseIDMapping = {
    3745: "ethics-governance",
    191474: "global-strategy-leadership",
    3806: "financial-reporting",
    3961: "strategic-management-accounting",
    5126: "advanced-audit-assurance",
    5187: "australia-taxation",
    5190: "contemporary-business-issues",
    371311: "financial-risk-management",
    94943: "australia-taxation-advanced",
    249353: "digital-finance"
}


const courseMappings = {
    3745: [
        {"pct" : 15, "hrs" : 14 },
        {"pct" : 20, "hrs" : 19 },
        {"pct" : 25, "hrs" : 24 },
        {"pct" : 25, "hrs" : 24 },
        {"pct" : 15, "hrs" : 14 },
    ],
    191474: [
        {"pct" : 10, "hrs" : 11 },
        {"pct" : 15, "hrs" : 14 },
        {"pct" : 15, "hrs" : 14 },
        {"pct" : 15, "hrs" : 14 },
        {"pct" : 15, "hrs" : 14 },
        {"pct" : 15, "hrs" : 14 },
        {"pct" : 15, "hrs" : 14 },
    ],
    3806: [
        {"pct" : 10, "hrs" : 14 },
        {"pct" : 14, "hrs" : 20 },
        {"pct" : 10, "hrs" : 14 },
        {"pct" : 18, "hrs" : 25 },
        {"pct" : 24, "hrs" : 33 },
        {"pct" : 14, "hrs" : 20 },
        {"pct" : 10, "hrs" : 14 },
    ],
    3961: [
        {"pct" : 10, "hrs" : 11 },
        {"pct" : 15, "hrs" : 16 },
        {"pct" : 22, "hrs" : 24 },
        {"pct" : 13, "hrs" : 14 },
        {"pct" : 23, "hrs" : 25 },
        {"pct" : 17, "hrs" : 19 },
    ],
    5126: [
        {"pct" : 20, "hrs" : 19 },
        {"pct" : 20, "hrs" : 19 },
        {"pct" : 20, "hrs" : 19 },
        {"pct" : 20, "hrs" : 19 },
        {"pct" : 20, "hrs" : 19 },
    ],
    5187: [
        {"pct" : 15, "hrs" : 15 },
        {"pct" : 25, "hrs" : 25 },
        {"pct" : 15, "hrs" : 14 },
        {"pct" : 15, "hrs" : 14 },
        {"pct" : 15, "hrs" : 14 },
        {"pct" : 15, "hrs" : 14 },
    ],
    5190: [
        {"pct" : 15, "hrs" : 11 },
        {"pct" : 20, "hrs" : 15 },
        {"pct" : 25, "hrs" : 19 },
        {"pct" : 20, "hrs" : 15 },
        {"pct" : 20, "hrs" : 15 },
    ],
    371311: [
        {"pct" : 10, "hrs" : 10 },
        {"pct" : 10, "hrs" : 10 },
        {"pct" : 14, "hrs" : 13 },
        {"pct" : 10, "hrs" : 10 },
        {"pct" : 14, "hrs" : 13 },
        {"pct" : 14, "hrs" : 13 },
        {"pct" : 14, "hrs" : 13 },
        {"pct" : 14, "hrs" : 13 },
    ],
    94943: [
        {"pct" : 13, "hrs" : 18 },
        {"pct" : 12, "hrs" : 17 },
        {"pct" : 12, "hrs" : 17 },
        {"pct" : 13, "hrs" : 18 },
        {"pct" : 10, "hrs" : 14 },
        {"pct" : 10, "hrs" : 14 },
        {"pct" : 10, "hrs" : 14 },
        {"pct" : 10, "hrs" : 14 },
        {"pct" : 10, "hrs" : 14 },
    ],
    249353: [
        {"pct" : 20, "hrs" : 19 },
        {"pct" : 15, "hrs" : 14 },
        {"pct" : 20, "hrs" : 19 },
        {"pct" : 25, "hrs" : 24 },
        {"pct" : 20, "hrs" : 19 },
    ]
}

function AssisCTAComponent(assistCourseId){
    const name = courseIDMapping[assistToMainMappings[assistCourseId]];
    const fullName = getCourseFullName(name);
    const url = `/classic/course/${name}`;
    return (
        <Paper
      variant="outlined"
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        //backgroundColor: theme.palette.action.hover, // Soft, non-intrusive background
        //borderColor: theme.palette.divider,
        borderRadius: 2,
        maxWidth: 650,
        mx: 'auto',
        my: 3,
      }}
    >
      {/* Text Section */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <SchoolIcon
          color="action" 
          sx={{ fontSize: 20, display: { xs: 'none', sm: 'block' } }} 
        />
        <Typography 
          variant="body2" 
          color="text.secondary"
          sx={{ textAlign: { xs: 'center', sm: 'left' } }}
        >
          Need more help? Try our full <strong>{fullName}</strong> course.
        </Typography>
      </Box>

      {/* Action Button */}
      <Button
        variant="text"
        size="small"
        endIcon={<ArrowForwardIcon sx={{ fontSize: 14 }} />}
        onClick={() => window.location.href = url}
        sx={{
          fontWeight: 600,
          textTransform: 'none',
          whiteSpace: 'nowrap',
          //color: theme.palette.primary.main,
          '&:hover': {
            backgroundColor: 'transparent',
            textDecoration: 'underline',
          },
        }}
      >
        View Course
      </Button>
    </Paper>
    );
}

function IntensiveDescriptionPaper() {
  return (
    <Paper 
      elevation={2} 
      sx={{ 
        width: '100%', 
        maxWidth: 1100, 
        mx: 'auto', 
        my: 3, 
        p: { xs: 3, md: 5 },
        borderRadius: 3,
        bgcolor: 'background.paper',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <Chip 
          label="High-Intensity Acceleration" 
          color="warning" 
          size="small" 
          variant="outlined"
          sx={{ mb: 2, fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: 1 }}
        />
        <Typography 
          variant="h3" 
          component="h2" 
          sx={{ 
            fontWeight: 800, 
            mb: 2,
            fontSize: { xs: '1.75rem', sm: '2.5rem' }
          }}
        >
          CPA Boost
        </Typography>
        <Typography 
          variant="body1" 
          color="text.secondary" 
          sx={{ maxWidth: 900, lineHeight: 1.7 }}
        >
          This is a zero-fluff acceleration track designed specifically for adult learners who are behind and need to grind through 10 weeks of material in half the time. It is demanding, fast-paced, and requires true grit, but it will get you caught up. Build your custom, high-speed study schedule below to outwork the timeline and take back control of your progress.
        </Typography>
      </Box>
    </Paper>
  );
}


// --- Radial bar chart ---

const toPolar = (cx, cy, r, a) => ({ x: cx + r * Math.cos(a), y: cy + r * Math.sin(a) });

const arcPath = (cx, cy, r1, r2, a1, a2) => {
    const p1 = toPolar(cx, cy, r1, a1), p2 = toPolar(cx, cy, r2, a1);
    const p3 = toPolar(cx, cy, r2, a2), p4 = toPolar(cx, cy, r1, a2);
    const lg = a2 - a1 > Math.PI ? 1 : 0;
    return `M ${p1.x} ${p1.y} L ${p2.x} ${p2.y} A ${r2} ${r2} 0 ${lg} 1 ${p3.x} ${p3.y} L ${p4.x} ${p4.y} A ${r1} ${r1} 0 ${lg} 0 ${p1.x} ${p1.y} Z`;
};

const MODULE_COLORS = ['#42a5f5','#1976d2','#7c43bd','#ab47bc','#26a69a','#66bb6a','#ffa726','#ef5350','#78909c','#8d6e63'];
const moduleColor = (m) => MODULE_COLORS[(m - 1) % MODULE_COLORS.length];

function BootcampRadialChart({ schedule, pe1Date, pe2Date, totalHours }) {
    const [tooltip, setTooltip] = useState(null);

    const SIZE = 580, cx = 290, cy = 290;
    const INNER_R = 95, OUTER_R = 220;
    const maxHours = Math.max(...schedule.map(d => d.hours));
    const n = schedule.length;
    const GAP_FRAC = 0.1;
    const slice = (2 * Math.PI) / n;
    const TICK_START = OUTER_R + 5;
    const TICK_END   = OUTER_R + 18;
    const labelR     = OUTER_R + 26;

    const bars = schedule.map((day, i) => {
        const gap = slice * GAP_FRAC;
        const a1 = i * slice - Math.PI / 2 + gap / 2;
        const a2 = (i + 1) * slice - Math.PI / 2 - gap / 2;
        const isPE1 = day.pe1 || day.date === pe1Date;
        const isPE2 = day.pe2 || day.date === pe2Date;
        const isRest = day.hours === 0 && !isPE1 && !isPE2;
        const barR = isPE1 || isPE2
            ? INNER_R + (OUTER_R - INNER_R) * 0.45
            : isRest
                ? INNER_R + 5
                : INNER_R + Math.max((day.hours / maxHours) * (OUTER_R - INNER_R), 6);
        const color = isPE1 ? '#ef5350' : isPE2 ? '#ff9800' : isRest ? '#000000' : moduleColor(day.module);
        return { ...day, path: arcPath(cx, cy, INNER_R, barR, a1, a2), color, isPE1, isPE2, isRest };
    });

    const modules = [...new Set(schedule.filter(d => d.module).map(d => d.module))].sort((a, b) => a - b);

    // Find Mondays and their positions
    const mondays = schedule
        .map((day, i) => {
            const d = new Date(day.date);
            return { day, index: i, date: d, dayOfWeek: d.getDay() };
        })
        .filter(({ dayOfWeek }) => dayOfWeek === 1);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <svg
                viewBox={`0 0 ${SIZE} ${SIZE}`}
                width="100%"
                style={{ maxWidth: SIZE, display: 'block' }}
                onMouseLeave={() => setTooltip(null)}
            >
                <text x={cx} y={55} textAnchor="middle" fontSize={12} fontWeight="600" fill="#666">
                    Start
                </text>
                <circle cx={cx} cy={cy} r={INNER_R} fill="none" stroke="#e0e0e0" strokeWidth={1} />
                {mondays.map(({ index, date }) => {
                    const a = index * slice - Math.PI / 2 + (slice / 2);
                    const p1  = toPolar(cx, cy, TICK_START, a);
                    const p2  = toPolar(cx, cy, TICK_END, a);
                    const pos = toPolar(cx, cy, labelR, a);
                    const cosA = Math.cos(a);
                    const anchor = cosA > 0.15 ? 'start' : cosA < -0.15 ? 'end' : 'middle';
                    return (
                        <g key={`monday-${index}`}>
                            <line
                                x1={p1.x} y1={p1.y}
                                x2={p2.x} y2={p2.y}
                                stroke="#bbb" strokeWidth={1}
                            />
                            <text
                                x={pos.x}
                                y={pos.y}
                                textAnchor={anchor}
                                dominantBaseline="middle"
                                fontSize={10}
                                fill="#888"
                                fontWeight="500"
                            >
                                {date.toLocaleDateString('en-GB', { month: 'short', day: 'numeric' })}
                            </text>
                        </g>
                    );
                })}
                {bars.map((bar, i) => (
                    <path
                        key={i}
                        d={bar.path}
                        fill={bar.color}
                        opacity={bar.isRest ? 0.35 : 0.85}
                        onMouseEnter={(e) => setTooltip({ x: e.clientX, y: e.clientY, bar })}
                        onMouseMove={(e) => setTooltip(t => t ? { ...t, x: e.clientX, y: e.clientY } : null)}
                        onMouseLeave={() => setTooltip(null)}
                    />
                ))}
                <text x={cx} y={cy - 8} textAnchor="middle" fontSize={24} fontWeight="bold" fill="#212121">
                    {totalHours}h
                </text>
                <text x={cx} y={cy + 14} textAnchor="middle" fontSize={12} fill="#757575">
                    total hours
                </text>
            </svg>

            <Stack direction="row" spacing={2} flexWrap="wrap" justifyContent="center" sx={{ mt: 1 }}>
                {modules.map(m => (
                    <Stack key={m} direction="row" alignItems="center" spacing={0.5}>
                        <Box sx={{ width: 12, height: 12, borderRadius: '2px', bgcolor: moduleColor(m) }} />
                        <Typography variant="caption">Module {m}</Typography>
                    </Stack>
                ))}
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Box sx={{ width: 12, height: 12, borderRadius: '2px', bgcolor: '#ef5350' }} />
                    <Typography variant="caption">Practice Exam 1</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Box sx={{ width: 12, height: 12, borderRadius: '2px', bgcolor: '#ff9800' }} />
                    <Typography variant="caption">Practice Exam 2</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Box sx={{ width: 12, height: 12, borderRadius: '2px', bgcolor: '#000000', border: '1px solid #ccc' }} />
                    <Typography variant="caption">Rest Day</Typography>
                </Stack>
            </Stack>

            {tooltip && (
                <Card
                    elevation={4}
                    sx={{ position: 'fixed', top: tooltip.y + 14, left: tooltip.x + 14, zIndex: 9999, pointerEvents: 'none', minWidth: 150 }}
                >
                    <CardContent sx={{ py: 1, px: 1.5, '&:last-child': { pb: 1 } }}>
                        <Typography variant="subtitle2" gutterBottom>{tooltip.bar.date}</Typography>
                        {tooltip.bar.isPE1 && <Typography variant="body2" color="error.main">Practice Exam 1</Typography>}
                        {tooltip.bar.isPE2 && <Typography variant="body2" color="warning.main">Practice Exam 2</Typography>}
                        {tooltip.bar.module != null && !tooltip.bar.isPE1 && !tooltip.bar.isPE2 && (
                            <Typography variant="body2">Module {tooltip.bar.module}</Typography>
                        )}
                        <Typography variant="body2">
                            {tooltip.bar.isRest ? 'Rest day' : `${tooltip.bar.hours} hrs`}
                        </Typography>
                    </CardContent>
                </Card>
            )}
        </Box>
    );
}

const EMPTY_FORM = { startDate: "", examDate: "", startModule: "" };

export default function Bootcamp() {

    const userContext = useContext(UserContext);
    const [course_data, setCourseData] = useState([]);
    const [formData, setFormData] = useState({});
    const [schedules, setSchedules] = useState({});
    const [editingCourses, setEditingCourses] = useState(new Set());
    const fetchedRef = useRef(new Set());

    const loadData = () => {
        getUserBootcampData(userContext.user, "1234")
            .then(response => response.json())
            .then(data => { setCourseData(data);})
            .catch(error => console.error(error));
    };

    useEffect(() => { loadData(); }, [userContext.user]);

    // Fetch schedule for courses that already have a bootcamp configured
    useEffect(() => {
        course_data
            .filter(c => c[`ke_bootcamp_${c.course_id}`] && !fetchedRef.current.has(c.course_id))
            .forEach(course => {
                fetchedRef.current.add(course.course_id);
                const data = course[`ke_bootcamp_${course.course_id}`];
                setSchedules(prev => ({ ...prev, [course.course_id]: data }));
                })
    }, [course_data]);

    const getVal = (courseId, field) => formData[courseId]?.[field] ?? "";

    const setVal = (courseId, field, value) =>
        setFormData(prev => ({
            ...prev,
            [courseId]: { ...(prev[courseId] ?? EMPTY_FORM), [field]: value },
        }));

    const handleSubmit = (e, courseId) => {
        e.preventDefault();
        const { startDate, examDate, startModule } = formData[courseId] ?? EMPTY_FORM;
        
        const mainCourse = assistToMainMappings[courseId] ? assistToMainMappings[courseId] : courseId;

        generateUserBootcampData(userContext.user, courseId, startModule, startDate, examDate, courseMappings[mainCourse])
            .then(r => r.json())
            .then(data => {
                if (data?.schedule) {
                    setSchedules(prev => ({ ...prev, [courseId]: data }));
                }
                setEditingCourses(prev => { const next = new Set(prev); next.delete(courseId); return next; });
                loadData();
            })
            .catch(error => console.error(error));
    };

    const startEditing = (courseId) => {
        const existing = schedules[courseId];
        const examDateRaw = course_data.find(c => c.course_id === courseId)?.[`ke_bootcamp_exam_date_${courseId}`];
        const startDate = existing?.schedule?.[0]?.date ?? "";
        const examDate = examDateRaw ? examDateRaw.slice(0, 10) : "";
        const startModule = existing?.schedule?.find(d => d.module != null)?.module ?? "";
        setFormData(prev => ({ ...prev, [courseId]: { startDate, examDate, startModule: String(startModule) } }));
        setEditingCourses(prev => new Set(prev).add(courseId));
    };

    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            <IntensiveDescriptionPaper />
            <Stack spacing={3}>
                {course_data.map(course => {
                    
                    if(courseMappings[course.course_id] === undefined)
                    {
                        if (assistToMainMappings[course.course_id] === undefined) 
                         return null;
                    }
                    const hasBootcamp = !!course[`ke_bootcamp_${course.course_id}`];
                    const isEditing = editingCourses.has(course.course_id);
                    const isAssist = assistToMainMappings[course.course_id] !== undefined;
                    
                    return (
                        <Card key={course.course_id} variant="outlined">
                            <CardHeader
                                title={decodeHtmlEntity(course.title)}
                                action={hasBootcamp && (
                                    <IconButton
                                        size="small"
                                        onClick={() => isEditing
                                            ? setEditingCourses(prev => { const next = new Set(prev); next.delete(course.course_id); return next; })
                                            : startEditing(course.course_id)
                                        }
                                        title={isEditing ? "Cancel edit" : "Edit schedule"}
                                    >
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                )}
                            />
                                <Box sx={{ ml: 4, mr:4, mb:3 }}>
                                    <Typography variant="body2" color="text.secondary">
                                        The graph shows how many hours per day you should study and how much time you should spend on each module according to their exam weighting.
                                    </Typography>
                                </Box>
                                <Box>
                                    {isAssist && (
                                        AssisCTAComponent(course.course_id)
                                    )}
                                </Box>
                            {hasBootcamp && schedules[course.course_id] && (
                                <>
                                    <CardContent>
                                        <Stack direction={{ xs: 'column', md: 'row' }} spacing={4} alignItems="flex-start">
                                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                                <BootcampRadialChart
                                                    schedule={schedules[course.course_id].schedule}
                                                    pe1Date={schedules[course.course_id].pe1_date}
                                                    pe2Date={schedules[course.course_id].pe2_date}
                                                    totalHours={schedules[course.course_id].total_hours}
                                                />
                                            </Box>
                                            <Stack spacing={2.5} sx={{ minWidth: 200 }}>
                                                <Box>
                                                    <Typography variant="caption" color="text.secondary">Practice Exam 1</Typography>
                                                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                                                        {schedules[course.course_id].pe1_date ? new Date(schedules[course.course_id].pe1_date).toLocaleDateString('en-GB') : '—'}
                                                    </Typography>
                                                </Box>
                                                <Box>
                                                    <Typography variant="caption" color="text.secondary">Practice Exam 2</Typography>
                                                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                                                        {schedules[course.course_id].pe2_date ? new Date(schedules[course.course_id].pe2_date).toLocaleDateString('en-GB') : '—'}
                                                    </Typography>
                                                </Box>
                                                <Box>
                                                    <Typography variant="caption" color="text.secondary">CPA Exam</Typography>
                                                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                                                        {course[`ke_bootcamp_exam_date_${course.course_id}`] ? new Date(course[`ke_bootcamp_exam_date_${course.course_id}`]).toLocaleDateString('en-GB') : '—'}
                                                    </Typography>
                                                </Box>
                                            </Stack>
                                        </Stack>
                                    </CardContent>
                                </>
                            )}
                            {(!hasBootcamp || isEditing) && (
                                <CardContent>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                        {hasBootcamp ? "Update your bootcamp schedule below." : "No bootcamp schedule set up yet. Fill in the details below to get started."}
                                    </Typography>
                                    <Box
                                        component="form"
                                        onSubmit={e => handleSubmit(e, course.course_id)}
                                        noValidate
                                    >
                                        <Stack spacing={2} direction="row">
                                            <TextField
                                                label="Start Date"
                                                type="date"
                                                required
                                                InputLabelProps={{ shrink: true }}
                                                value={getVal(course.course_id, "startDate")}
                                                onChange={e => setVal(course.course_id, "startDate", e.target.value)}
                                                fullWidth
                                            />
                                            <TextField
                                                label="Exam Date"
                                                type="date"
                                                required
                                                InputLabelProps={{ shrink: true }}
                                                value={getVal(course.course_id, "examDate")}
                                                onChange={e => setVal(course.course_id, "examDate", e.target.value)}
                                                fullWidth
                                            />
                                            <TextField
                                                label="Current Module"
                                                type="number"
                                                required
                                                inputProps={{ min: 1 }}
                                                value={getVal(course.course_id, "startModule")}
                                                onChange={e => setVal(course.course_id, "startModule", e.target.value)}
                                                fullWidth
                                            />
                                            <Button type="submit" variant="contained" sx={{ alignSelf: "flex-start" }}>
                                                Go!
                                            </Button>
                                        </Stack>
                                    </Box>
                                </CardContent>
                            )}
                        </Card>
                    );
                })}
            </Stack>
        </Container>
    );
}